import React from 'react';
import {useTranslation} from "../../../PlattixReactCore/i18n";

export function NoPermissionErrorComponent() {
    const {t} = useTranslation()

    return <h1>{t('Response.Forbidden')}</h1>
}